import TwelveLaboursHeader from './src/TwelveLaboursHeader';

/* istanbul ignore next */
TwelveLaboursHeader.install = function(Vue) {
  Vue.component(TwelveLaboursHeader.name, TwelveLaboursHeader);
};

export default TwelveLaboursHeader;
